export type { Location } from '__generated__/graphql/types'

export enum LocationType {
    ONSHORE='ONSHORE',
    OFFSHORE='OFFSHORE'
}